import React from "react";
import ReportPage from "./ReportPage";

export default function NetPaySchedule() {
  return (
    <ReportPage
      title="Net Pay Schedule"
      subtitle="Net pay payment schedule."
      endpoint="/reports/net-pay"
      exportName="net-pay"
      summaryCards={[
        { key: "staff_count", label: "Staff Count" },
        { key: "total_net", label: "Total Net", money: true },
      ]}
      columns={[
        { key: "pf_no", label: "PF No" },
        { key: "fullname", label: "Name" },
        { key: "bank_name", label: "Bank" },
        { key: "account_number", label: "Account No" },
        { key: "net", label: "Net Pay" },
      ]}
    />
  );
}
